import { render } from "./IconArrow.vue?vue&type=template&id=4aed9b68"
import script from "./IconArrow.vue?vue&type=script&lang=ts"
export * from "./IconArrow.vue?vue&type=script&lang=ts"
script.render = render

export default script